//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'swiper/dist/css/swiper.css'
import {swiper,swiperSlide} from 'vue-awesome-swiper';
import missingData from '../../testdata/missing';
import {mapActions} from 'vuex';
import force from '../../common/forceLandscape';

let timer=null;
export default {
      name: "topic",
    components:{
      swiper,
      swiperSlide
    },
    data(){
        return{
          swiperOptions:{
            noSwiping:true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on:{
              slideChange: ()=>{
                this.index=this.$refs.swiper.swiper.activeIndex;
              },
            },
          },
          index:0,
          missingData:[],
          buildData:[],
          error:0,
          zhengque:0,
          leftTime:20,
          recording:false
        }
    },
    methods:{
      ...mapActions(['changeTestStatus']),
      shuffle(){
        this.missingData.sort(()=>{
          return Math.random()-0.5;
        })
        return Promise.resolve('success');
      },
      checkAnswer(res){
        var swiperindex=this.$refs.swiper.swiper.activeIndex;
        if(!res){
          this.$vux.toast.text('回答错误','center');
          this.error++;
          if(this.error>=5){
            this.changeTestStatus({name:'missing',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
              this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
            });
          }
        }else{
          this.zhengque++;
          this.$vux.toast.text('回答正确','center');
        }
        if(swiperindex>=7){
          this.changeTestStatus({name:'missing',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
            this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
          });
        }
        this.$refs.swiper.swiper.slideTo(swiperindex+1);
      },
      xuhao(number){
        return String.fromCharCode(64+number+1).toUpperCase();
      }
    },
    created() {
      var routename=this.$route.name;
      var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
      var index=tixing.indexOf(routename);
      var title=`Test ${index+1} ${this.$store.state.title['lv'+this.$store.state.testLevel][index]}`;
      document.title=title;
      this.missingData=missingData['lv'+this.$store.state.testLevel];
      this.shuffle().then(_=>{
        for(let i=0;i<this.missingData.length;i++){
          this.missingData[i].choose.sort(()=>{
            return Math.random()-0.5;
          })
        }
        this.buildData=this.missingData.slice(0,14);
      })
    },
    mounted() {
        force();
    }
}



// WEBPACK FOOTER //
// ./src/components/missing/missing.vue